module.exports = __webpack_public_path__ + "static/media/flag-germany.3c29eda9.svg";